import { useState } from 'react';

import { IconLogout } from '@tabler/icons-react';
import { useAtom } from 'jotai';

import useSignOut from 'api/logout/logout';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import IconButton from '@lotlinx-aws/sparky-component-library/Sparky/IconButton';
import Popover from '@lotlinx-aws/sparky-component-library/Sparky/Popover';
import { COLOR } from '@lotlinx-aws/sparky-component-library/Sparky/styles/vars';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';
import Tooltip from '@lotlinx-aws/sparky-component-library/Sparky/Tooltip';
import { userAtom } from 'store';

import styles from './UserButton.module.scss';

export interface UserButtonProps {
  isTooltipDisabled: boolean;
}

/**
 * UserButton
 */
export default function UserButton({ isTooltipDisabled }: UserButtonProps) {
  const [user, setUser] = useAtom(userAtom);
  const [isOpenUserProfile, setIsOpenUserProfile] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const mutation = useSignOut();

  const handleSignOut = () => {
    setUser(undefined);
    if (user) {
      mutation.mutate(user.token);
    }
  };

  return (
    <div className={styles.userbutton}>
      <Popover
        isOpen={isOpenUserProfile}
        setIsOpen={setIsOpenUserProfile}
        showCloseButton={false}
        side='right'
        align='end'
        verticalOffset={8}
        contentClassName={styles.userProfileLists}
        popupContent={
          <Flex padding='20px' justifyContent='space-between' alignItems='center' width='300px'>
            <Flex column rowGap='8px'>
              <Text size='14'>
                {user?.first} {user?.last}
              </Text>
              <Text size='14' color='secondary'>
                {user?.email}
              </Text>
            </Flex>

            <Tooltip content={'logout'} side={'top'} open={showTooltip}>
              <IconButton
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
                aria-label='logout button'
                size='lg'
                onClick={handleSignOut}
              >
                <IconLogout size={24} color={COLOR.SPARKY_NAVY_400} />
              </IconButton>
            </Tooltip>
          </Flex>
        }
      >
        <button className={styles.avatar} aria-label='User profile'>
          <Tooltip
            disabled={isTooltipDisabled && !user}
            content={user && `${user.first} ${user.last}`}
            side='right'
          >
            <div>{user && `${user.first.charAt(0)}${user.last.charAt(0)}`.toUpperCase()}</div>
          </Tooltip>
        </button>
      </Popover>
    </div>
  );
}

// interface UserProfileListProps {
//   label: string;
//   icon?: React.ReactElement;

//   handleClick(): void;
// }

// function UserProfileList({ label, icon, handleClick }: UserProfileListProps) {
//   return (
//     <button className={styles.userProfileList} onClick={() => handleClick()} aria-label={label}>
//       <Text>{label}</Text>
//       {icon && <Text className={styles.icon}>{icon}</Text>}
//     </button>
//   );
// }
